export default "__VITE_PUBLIC_ASSET__08478c2b__"